import { MealServiceType } from '@constants/meals.constants';
import {
  MealsChangeSelectionPayload,
  MealsSetSameForAllFlightsPayload,
  MealsSetSameForAllPaxPayload,
  MealsSsrPassengerUpdateRequest,
} from '@models/cms/meals.model';
import { JourneyMealAddPayload, MealPassenger, SelectPassengerMealPayload, SelectSamePassengersMealForReturnFlight } from '@models/meals.model';
import { createAction, props } from '@ngrx/store';

export const enum MealActionTypes {
  setMealsSelection = '[meals] SET_MEALS_SELECTION',
  setMealsSameForAllPax = '[meals] SET_MEALS_SAME_FOR_ALL_PAX',
  setMealsSameForAllFlights = '[meals] SET_MEALS_SAME_FOR_ALL_FLIGHTS',
  changeMealsSelection = '[meals] CHANGE_MEALS_SELECTION',
  validateMealsSelection = '[meals] VALIDATE_MEALS_SELECTION',
  sellMealsSelected = '[meals] SELL_MEALS_SELECTED',
  sellMealsSsrSuccess = '[meals] SELL_MEALS_SSR_SUCCESS',
  selectPassengerMeal = '[meals] SELECT_PASSENGER_MEAL',
  selectSamePassengersMealForReturnFlight = '[meals] SELECT_SAME_PASSENGERS_MEAL_FOR_RETURN_FLIGHT',
  clearJourneyMeal = '[meals] CLEAR_JOURNEY_MEAL',
  selectDefaultPassengersMeals = '[meals] SELECT_DEFAULT_PASSENGERS_MEALS'
}

export const mealsSetSelection = createAction(
  MealActionTypes.setMealsSelection,
  props<{ payload: MealsSsrPassengerUpdateRequest[] }>(),
);

export const mealsChangeSelection = createAction(
  MealActionTypes.changeMealsSelection,
  props<{ payload: MealsChangeSelectionPayload }>(),
);

export const mealsSetSameForAllPax = createAction(
  MealActionTypes.setMealsSameForAllPax,
  props<{ payload: MealsSetSameForAllPaxPayload }>(),
);

export const mealsSetSameForAllFlights = createAction(
  MealActionTypes.setMealsSameForAllFlights,
  props<{ payload: MealsSetSameForAllFlightsPayload }>(),
);

export const mealsValidateSelection = createAction(
  MealActionTypes.validateMealsSelection,
);

export const mealsSellSelectedMeals = createAction(
  MealActionTypes.sellMealsSelected,
  (payload: {redirectToPayment: boolean} = {redirectToPayment: true}) => payload,
);

export const mealsSellMealsSsrSuccess = createAction(
  MealActionTypes.sellMealsSsrSuccess,
  props<{ redirectToPayment?: boolean }>(),
);

export const selectPassengerMeal = createAction(
  MealActionTypes.selectPassengerMeal,
  props<{ payload: SelectPassengerMealPayload }>(),
);


export const selectSamePassengersMealForReturnFlight = createAction(
  MealActionTypes.selectSamePassengersMealForReturnFlight,
  props<{ payload: SelectSamePassengersMealForReturnFlight }>(),
);

export const clearJourneyMeal = createAction(
  MealActionTypes.clearJourneyMeal,
  props<{serviceType: MealServiceType}>()
)

export const selectDefaultPassengersMeals = createAction(
  MealActionTypes.selectDefaultPassengersMeals,
  props<{addPayload: JourneyMealAddPayload}>()
)
